import { NotificationService } from '@/services/notificationService';
import { tasksService } from '@/services/api/tasksService';
import { extractApiErrorMessage } from '@/utils/apiErrorMessage';
import type { TaskStatus } from '@/types';

const ERROR_CODE_I18N: Record<string, string> = {
  TASK_RELATED_TASKS_INCOMPLETE: 'tasks.errors.relatedTasksIncomplete',
  TASK_REQUIREMENTS_INCOMPLETE: 'tasks.errors.requirementsIncomplete',
};

export async function performStatusChange(
  taskId: string,
  newStatus: TaskStatus,
  oldStatus: TaskStatus,
  setTaskStatus: (id: string, status: TaskStatus) => void
): Promise<boolean> {
  setTaskStatus(taskId, newStatus);

  try {
    await tasksService.updateStatus(taskId, newStatus);
    return true;
  } catch (error: unknown) {
    setTaskStatus(taskId, oldStatus);
    NotificationService.showError(
      extractApiErrorMessage(
        error,
        ERROR_CODE_I18N,
        'tasks.errors.statusChangeFailed'
      )
    );
    return false;
  }
}
